import axios from 'axios';
import { BASE_URL } from '../configs/api';

const axiosServices = axios.create({ baseURL: BASE_URL });
axiosServices.interceptors.request.use(
  async (config) => {
    const tokenData = JSON.parse(localStorage.getItem("user_profile") || "null");

    if (tokenData?.accessToken) {
      config.headers["Authorization"] = `Bearer ${tokenData.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response call
axiosServices.interceptors.response.use(
  (next) => {
    return Promise.resolve(next.data);
  },
  async (error) => {
    if (error?.response?.status === 401) {
      const originalRequest = error.config;
      const tokenData = JSON.parse(localStorage.getItem("user_profile") || "null");

      if (tokenData?.refreshToken && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const refreshResponse = await axios.post(`${BASE_URL}Auth/refresh`, {
            refreshToken: tokenData.refreshToken,
          });
          const newTokens = refreshResponse?.data?.data;

          if (newTokens?.accessToken) {
            localStorage.setItem("user_profile", JSON.stringify(newTokens, null, 2));
            originalRequest.headers["Authorization"] = `Bearer ${newTokens.accessToken}`;
            return axiosServices(originalRequest);
          }
        } catch (refreshError) {
          // fall through to logout
        }
      }

      localStorage.clear();
      window.location.href = "/";
    }
    // You can handle error here and trigger warning message without get in the code inside
    return Promise.reject(error);
  },
);

export default axiosServices;
